import {ItemToolEditor} from "./CreatePriceGroup.jsx";
export default function CreateBrand(props){return <ItemToolEditor {...props} kind="brand"/>;}
